import React from 'react';
import ReactDOM from 'react-dom';
import FormItemEditor from './FormItemEditor';
import {RecordFieldChangeStore} from '../stores/RecordsStore';
import RecordsActions from '../actions/RecordsActions';
import FocusActions from '../actions/FocusActions';
import FormItemConst from './FormItemConst';
require('../styles/FormItemBoolean.css');

export default class FormItemBooleanEditor extends FormItemEditor
{
	constructor(props) {
		super(props);
		if(!this.props.forLookup)
			this.unsubscribeRecordFieldChangeStore = RecordFieldChangeStore.listen(this.onDataFieldChanged.bind(this));
	}

	componentWillUnmount()
	{
		this.distroyCommonStores();
		if(!this.props.forLookup)
			this.unsubscribeRecordFieldChangeStore();
	}

	onDataFieldChanged(record,dataField,oldValue,newValue,observer)
	{
		if(observer != this && this.props.dataField == dataField && record == this.record)
			this.setDisplay(newValue);
		//else 
		//	alert("observer is this!");
	}

	onMapEditorsHandler(selector,mapEditorValues,moduleInstanceId)
	{
		if((this.props.groupAlias == "" || !this.props.groupAlias) && this.props.moduleInstanceId == moduleInstanceId)
		{
			if(selector!="all" && this.props.xml.name != selector)
				return;
			if(this.props.underQueryGroup && !this.getInQueryGroupNow())
				return;
			if(typeof(this.record) == "boolean")
			{
				mapEditorValues[this.props.xml.name] = this.record+"";
			}
			else
			{
				mapEditorValues[this.props.xml.name] = 
					(!this.record||this.record == "")?(this.props.defaultValueForCMD+""):(this.record+"");	
			}
			
		}
		
	}

	onCmdUpdateControlProperty(name,property,value,moduleInstanceId)
	{
		if(name != this.props.xml.name || this.props.moduleInstanceId)
			return;
		if(property == ControlPropertyConst.NOTNULL)
			this.setState({notNull:value});
	}

	onFocusSet(formId,itemId,pre,init)
	{
		if(this.props.formId == formId && this.props.xml.id == itemId)
		{
			$(this.inputField).focus();
			//$(this.inputField).select();
		}
	}

	inputFieldFocus(e)
	{
		//alert("focus");
		$(this.editorGroup).find(".icheckbox_minimal-blue14").css({outline:'2px solid #66afe9',outlineOffset:'1px'});
		window.lastFocusUI = this.inputField;
		if(this.props.groupAlias)
			window.lastEditedDataFields[this.props.groupAlias] = this.props.dataField;
		FocusActions.currentGroupSet(this.props.groupAlias,this.props.formId);
	}

	inputFieldBlur()
	{
		$(this.editorGroup).find(".icheckbox_minimal-blue14").css({outline:"none"});
		if(this.holdFocus)
		{
			$(this.inputField).focus();
			$(this.inputField).select();
		}
	}
	inputFieldOnClick(){
		if(this.props.underQueryGroup){
			this.inQueryGroup =true;
			this.state.notNull = false
			this.setState({allowEdit:true,nullValue:false})
			$(this.inputField).parent().removeClass("disabled");
			let _value = (this.record&&typeof(this.record)=="object"&&this.props.dataField)?this.record[this.props.dataField]:this.record;
			let boolvalue = (_value == "true" || _value == true || _value == "1");
			if(!boolvalue)
			{
				//update this.inputField.checked = true;
				$(this.inputField).iCheck('check');   //将输入框的状态设置为checked 
			}
			else
			{
				//update this.inputField.checked = false;
				$(this.inputField).iCheck('uncheck');
			}
		}
	}
	inputCloseOnClick(){
		$(this.inputField).val('');
		this.record='';
		this.setState({allowEdit:false,nullValue:false})
		$(this.inputField).parent().addClass("disabled");
		$(this.inputField).iCheck('uncheck');
		this.inQueryGroup = false;
		
	}

	onCurrentRecordChanged(records,currentRecord,groupAlias,moduleInstanceId)
	{
		super.onCurrentRecordChanged(records,currentRecord,groupAlias,moduleInstanceId);
		//alert(this.props.groupAlias + groupAlias);
		if(this.props.groupAlias == groupAlias && moduleInstanceId == this.props.moduleInstanceId)
		{
			let _value = (this.record&&typeof(this.record)=="object"&&this.props.dataField)?this.record[this.props.dataField]:this.record;
			let boolvalue = (_value == "true" || _value == true || _value == "1");
			if(boolvalue)
			{
				//update this.inputField.checked = true;
				$(this.inputField).iCheck('check');   //将输入框的状态设置为checked 
			}
			else
			{
				//update this.inputField.checked = false;
				$(this.inputField).iCheck('uncheck');
			}

			if(this.props.control)
			{

				var _allowEdit = true;
				if(!this.record && groupAlias)
				{
					_allowEdit = false;
				}
				else
				{
					_allowEdit = this.props.control.getProperty_AllowEdit_Final();
				}
				this.doSetEnable(_allowEdit);	
			}
		}
	}

	//TODO setFinalValue继承自了超类
	selectedChanged(value)
	{
		//todo 校验 需要考虑是否可编辑 将来有可能被放到Dialog及查询器上
		if(this.errorRecord != undefined){
			this.errorRecord = undefined;
			return;
		}
		if(!this.props.dataField)
		{
			//update var value = this.inputField.checked;
			if(this.record == value)
				return;
			this.record = value;
			if(this.props.groupAlias == "" || !this.props.groupAlias)
			{
				if(this.props.control)
				{
					this.props.control.doModifiedEditor(!value, value,this);
				}
			}
		}
		else
		{
			let changed = false;
			let oldValue = this.record[this.props.dataField];
			//update let newValue = this.inputField.checked;
			let newValue = value;
			if(oldValue != newValue)
				changed = true;
			this.record[this.props.dataField] = newValue;
			//alert("派发");	
			if(changed)
			{
				RecordsActions.RecordFieldChanged(this.record,this.props.dataField,oldValue,newValue,this);
				if(this.props.control)this.props.control.doFieldModifiedRemote(this.props.dataField,newValue+"",oldValue+"",null,this);
			}			
				
		}
		
		//todo 值回送数据完成以后 严格按照显示要求再进行显示
		//对于boolean 与 Enum 不存在显示要求 所以不需要重新显示
		//this.setDisplay();
		
	}

	restoreValue(value){
		if(value == undefined || value == null)
		{
			if(this.props.dataField && this.record)
				value = this.record[this.props.dataField];
			else
				value = this.record;
		}
		let boolvalue = (value == "true" || value == true || value == "1");

		//update this.inputField.checked = value;
		let _this = this;
		setTimeout(function(e){
			if(_this.props.dataField && _this.record){
				_this.record[_this.props.dataField] = Boolean(value);
			}else{
				_this.record = value;
			}
			_this.errorRecord = value;
			if(boolvalue){
				$(_this.inputField).iCheck("check");
			}else {		
				$(_this.inputField).iCheck("uncheck")
			};
		},400)

	}

	setDisplay(value)
	{
		if(value == undefined || value == null)
		{
			if(this.props.dataField && this.record)
				value = this.record[this.props.dataField];
			else
				value = this.record;
		}
		let boolvalue = (value == "true" || value == true || value == "1");
		//update this.inputField.checked = value;
		if(boolvalue)$(this.inputField).iCheck("check");else $(this.inputField).iCheck("uncheck");
	}

	setDisplayFieldText(value,triggerModify = true)
	{
		let boolvalue = (value == "true" || value == true || value == "1");
		//update this.inputField.checked = value;
		if(boolvalue)$(this.inputField).iCheck("check");
		else 
		{
			//todo 由于iCheck源代码在执行uncheck指令时会判断checked属性 如果没有该属性或者有并且值为false则不做处理
			//所以在执行该指令之前 要先设置该属性为true
			$(this.inputField).prop("checked",true);
			$(this.inputField).iCheck("uncheck");
		}
		//this.setFinalValue(value,triggerModify);
		
		if(!this.props.dataField)
		{
			//update var value = this.inputField.checked;
			if(this.record == value)
				return;
			this.record = value;
			if(this.props.groupAlias == "" || !this.props.groupAlias)
			{
				if(this.props.control && triggerModify)
				{
					this.props.control.doModifiedEditor(!value, value);
				}
			}
		}
		else
		{
			let changed = false;
			let oldValue = this.record[this.props.dataField];
			//update let newValue = this.inputField.checked;
			let newValue = value;
			if(oldValue != newValue)
				changed = true;
			this.record[this.props.dataField] = newValue;
			//alert("派发");	
			if(changed && triggerModify)
			{
				RecordsActions.RecordFieldChanged(this.record,this.props.dataField,oldValue,newValue,this);
				if(this.props.control)this.props.control.doFieldModifiedRemote(this.props.dataField,newValue+"",oldValue+"");
			}			
				
		}

	}
	setDisplayFieldBooleanText(value,triggerModify = true){
		let boolvalue = (value == "true" || value == true || value == "1");
		//update this.inputField.checked = value;
		if(boolvalue)$(this.inputField).iCheck("check");
		else 
		{
			//todo 由于iCheck源代码在执行uncheck指令时会判断checked属性 如果没有该属性或者有并且值为false则不做处理
			//所以在执行该指令之前 要先设置该属性为true
			$(this.inputField).prop("checked",true);
			$(this.inputField).iCheck("uncheck");
		}
		//this.setFinalValue(value,triggerModify);
		
		if(!this.props.dataField)
		{
			//update var value = this.inputField.checked;
			if(this.record == value)
				return;
			this.record = value;
			if(this.props.groupAlias == "" || !this.props.groupAlias)
			{
				if(this.props.control && triggerModify)
				{
					this.props.control.doModifiedEditor(!value, value);
				}
			}
		}
		else
		{
			let changed = false;
			let oldValue = this.record[this.props.dataField];
			//update let newValue = this.inputField.checked;
			let newValue = value;
			if(oldValue != newValue)
				changed = true;
			this.record[this.props.dataField] = newValue;
			//alert("派发");	
			if(changed && triggerModify)
			{
				RecordsActions.RecordFieldChanged(this.record,this.props.dataField,oldValue,newValue,this);
				if(this.props.control)this.props.control.doFieldModifiedRemote(this.props.dataField,newValue+"",oldValue+"");
			}			
				
		}
		$(this.inputField).parent().addClass("disabled");
		this.inQueryGroup = false;
	}


	inputFieldClick()
	{
		$(this.inputField).focus();
		if(this.props.underQueryGroup){
			$(this.inputField).parent().removeClass("disabled");
			this.inQueryGroup = true;
		}
	}

	componentDidMount()
	{
		super.componentDidMount();
		$(this.editorGroup).contextPopup(this.props.contextMenuData);
		if(this.props.underQueryGroup)
		{
			this.doSetEnable(false);
		}
		else
		{
			let _initRecord;
			if(this.props.dataField)
			{
				_initRecord = this.props.initRecord;
			}
			else
			{
				if(this.props.control.hasInitEditorValue)
				{
					_initRecord = this.props.initEditorValue;	
				}
				else
				{
					_initRecord = this.props.initRecord;
				}
			}
			this.onCurrentRecordChanged(null,_initRecord,this.props.groupAlias,this.props.moduleInstanceId);
		}
		$(this.inputField).on('ifChecked',this.selectedChanged.bind(this,true));
		$(this.inputField).on('ifClicked',this.inputFieldClick.bind(this));
		$(this.inputField).on('ifUnchecked',this.selectedChanged.bind(this,false)); 
		let _checkboxClass = 'icheckbox_minimal-blue14 outDataGrid_checkbox';
		//if(!this.state.allowEdit)
			//_checkboxClass += ' disabled';
		$(this.inputField).iCheck({
	      checkboxClass: _checkboxClass
		});
		if(this.props.underQueryGroup){
			return;
		}
		if(!this.state.allowEdit)
			$(this.inputField).iCheck('disable');
	}

	doSetEnable(enable)
	{
		var nowAllowEdit = $(this.inputField).attr("disabled")==undefined;
		if(nowAllowEdit == true && enable == false)
		{
			this.setState({allowEdit:false});
			//$(this.inputField).attr("disabled",true);
		}
		else if(nowAllowEdit == false && enable == true)
		{
			this.setState({allowEdit:true});
			//$(this.inputField).removeAttr("disabled");
		}
	}

	componentDidUpdate()
	{
		if(this.props.underQueryGroup){
			return;
		}
		if(this.state.allowEdit)
		{
			$(this.inputField).parent().removeClass("disabled");
			//$(this.inputField).iCheck('enable');
		}
		else
		{
			$(this.inputField).parent().addClass("disabled");
			
			//$(this.inputField).iCheck('disable');
		}
	}

	onKeyDownHandler(e)
	{		
		if(9===e.keyCode || 13===e.keyCode)
		{
			//alert(e.shiftKey)
			e.preventDefault();
			FocusActions.focusChange(this.props.xml,e.shiftKey);
		}
	}

	getDisplayFieldText()
	{
	   return this.inputField.checked;
	}

	

	getInputDom()
	{
		let _style = {};
		if(this.props.customStyle)Object.assign({},_style);
		if(this.state.allowEdit)
		{

			if(this.props.underQueryGroup){
				return <div style={{marginRight:'10px'}}>
				<input type="checkbox" className="minimal" ref={ node => this.inputField = node } style={_style} 
					onKeyDown={this.onKeyDownHandler.bind(this)} onFocus={this.inputFieldFocus.bind(this)}
					onBlur={this.inputFieldBlur.bind(this)}/>
				<i className="fa fa-times-circle" style={{position: 'absolute',top:'10px',marginLeft:'2px',zIndex:'1000',fontSize:'1px',color:'gray'}} onClick={this.inputCloseOnClick.bind(this)}></i>	
			</div>
			}else{
				return <input type="checkbox" className="minimal" ref={ node => this.inputField = node } style={_style} 
					onKeyDown={this.onKeyDownHandler.bind(this)} onFocus={this.inputFieldFocus.bind(this)}
					onBlur={this.inputFieldBlur.bind(this)}/>

			}


		}
		else
		{
			//disabled={true} 
			if(this.props.underQueryGroup){
				return <div onClick={this.inputFieldOnClick.bind(this)}>
				<input type="checkbox" className="minimal" ref={ node => this.inputField = node } style={_style}  
					onKeyDown={this.onKeyDownHandler.bind(this)} onFocus={this.inputFieldFocus.bind(this)} 
					disabled={true} onBlur={this.inputFieldBlur.bind(this)} onClick={this.inputFieldOnClick.bind(this)}/>
					<i className="fa fa-times-circle" style={{display:'none',position: 'absolute',top:'10px',marginLeft:'2px',zIndex:'1000',fontSize:'3px'}} onClick={this.inputCloseOnClick.bind(this)}></i>	
				</div>
			}else{

			return  <input type="checkbox" className="minimal" ref={ node => this.inputField = node } style={_style}  
					onKeyDown={this.onKeyDownHandler.bind(this)} onFocus={this.inputFieldFocus.bind(this)} 
					disabled={true} onBlur={this.inputFieldBlur.bind(this)} />
			}
		
		}
	}

	render()
	{
		/*let _inputdivstyle = {width:'auto',paddingLeft:'5px'};
		if(this.props.underFieldGroup)
			_inputdivstyle.top = '6px';*/
		let notNull=this.props.notNull;
		var _notNullStyle={};
		_notNullStyle['fontSize']='8px';
    	_notNullStyle['color']='red';
		if(!notNull)
			_notNullStyle['visibility']='hidden';

		let editorStyle = {display:'flex',flexDirection:'row',alignItems:'center'};
		/*let displayHeight = this.props.control.getProperty_DisplayHeight();
		if(displayHeight == 1)
			editorStyle.height = "27px";*/
		if(this.state.visible == false)
			if(this.state.hideInVisible == true) editorStyle.display="none"; else editorStyle.visibility="hidden";
		let inputdom = this.getInputDom();
		let labelStyle={paddingLeft:'5px',width:'auto',whiteSpace:'nowrap',textAlign:'right',marginBottom:'-2px'
						,height:'24px',lineHeight:'24px'};
		// if(this.state.underQueryGroup && !this.inQueryGroup)
		// {
		// 	labelStyle.cursor = "pointer";labelStyle.color = "#CFCFCF";
		// }
		if(!this.state.label){labelStyle.display = "none";_notNullStyle.display = "none"}
		return(
			<div id={this.props.xml.name} className='editorGroup' style={editorStyle} ref={node => this.editorGroup = node}>
			  <label htmlFor={"input"+this.props.xml.id} className="fieldGroupLabel" ref={node => this.componentLabel = node} style={labelStyle} onClick={this.labelClickHandler.bind(this)}>
			  	  {this.state.label}
			  </label>
			  <i className='fa fa-snowflake-o' style={_notNullStyle}></i>
			  {inputdom}
			</div>

			/*
				<div style={{display:'flex',flexDirection:'row',alignItems:'center'}}>
					<label htmlFor={"input"+this.props.xml.id} className="fieldGroupLabel"
						style={{paddingLeft:'5px',paddingRight:'5px',width:'auto'}}>{this.props.xml.name}</label>
					<div>
				        <input ref='inputdomtime' id={"input"+this.props.xml.id} type="text" className="form-control" style={{padding:'2px',width:inputWidth}}/>
				    </div>
				</div>
			*/
		);
	}
}


// WEBPACK FOOTER //
// ./src/formItem/FormItemBooleanEditor.js